import type { ProductDto } from "@gaole/shared";

/** Shop singles eligible for FlexxiPlan deposit (not packs or credit packs). */
export function isFlexxiShopProduct(product: ProductDto): boolean {
  if (product.type === "CREDIT_PACK" || product.behavior === "CREDIT_PACK") return false;
  if (product.type === "PACK" || product.behavior === "PACK") return false;
  return product.type === "SINGLE" || product.behavior === "SINGLE";
}

export function pickFlexxiCartLine(
  items: { quantity: number; product: ProductDto }[],
  packLineCount: number,
): { productId: string; quantity: number } | null {
  if (packLineCount > 0 || items.length !== 1) return null;
  const line = items[0];
  if (!line || !isFlexxiShopProduct(line.product)) return null;
  return { productId: line.product.id, quantity: line.quantity };
}
